import { render, staticRenderFns } from "./SubmitholdOrder.vue?vue&type=template&id=0dd7e4a9&scoped=true&"
import script from "./SubmitholdOrder.vue?vue&type=script&lang=js&"
export * from "./SubmitholdOrder.vue?vue&type=script&lang=js&"
import style0 from "./SubmitholdOrder.vue?vue&type=style&index=0&id=0dd7e4a9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd7e4a9",
  null
  
)

export default component.exports